import {
    AudioDeviceInfo,
    Call,
    CallAgent,
    CallClient,
    CallEndReason,
    CommunicationServicesError,
    DeviceAccess,
    DeviceManager,
    GroupCallLocator,
    HangUpOptions,
    JoinCallOptions,
    RemoteParticipant,
    VideoDeviceInfo
} from '@azure/communication-calling';
import {
    ChatClient, ChatMessage, ChatMessageReadReceipt, ChatParticipant, ChatThreadClient,
    SendReadReceiptRequest
} from '@azure/communication-chat';
import {
    AzureCommunicationTokenCredential,
    CommunicationTokenRefreshOptions,
    CommunicationUserIdentifier, CommunicationUserKind
} from '@azure/communication-common';
import {
    ChatThreadPropertiesUpdatedEvent,
    ParticipantsAddedEvent,
    ParticipantsRemovedEvent
} from '@azure/communication-signaling';
import { setLogLevel } from '@azure/logger';
import { connection, signalR } from 'App';
import { INITIAL_MESSAGES_SIZE, PAGE_SIZE } from 'core/constants';
import { Dispatch } from 'redux';
import { UserLocalSettings } from '../components/LocalSettings';

import { IRemoteLocalSettingsProps } from '../components/RemoteLocalSettings';
import { URLOptionsConstants } from '../core/constants';
import { compareMessages, convertToClientChatMessage, createNewClientChatMessage, DeviceType, HasCallMode, IsCandidateMode, IsInterlocutorMode, isUserMatchingIdentity, UserCommand, utils, IsProctorMode, IsCentralScreenMode, IsSecondaryStream, ShouldUserBeMuted, IsHiddenUser } from '../Utils/Utils';
import { callAdded, callRemoved, setCallAgent, setCallState, setParticipants } from './actions/calls';
import { setChatClient, setContosoUser, setContosoUsers } from './actions/ContosoClientAction';
import { setMic, setShareScreen, setHelpClicked } from './actions/controls';
import { setReceipts } from './actions/ConversationsAction';
import {
    setAudioDeviceInfo,
    setAudioDeviceList,
    setCameraPermission, setDeviceManager, setMicrophonePermission,
    setVideoDeviceInfo,
    setVideoDeviceList
} from './actions/devices';
import { setFailedMessages, setMessages, setTypingNotifications, setTypingUsers } from './actions/MessagesAction';
import { setCallClient, setUserId } from './actions/sdk';
import { addScreenShareStream, removeScreenShareStream } from './actions/streams';
import { setThreadId, setThreadTopicName } from './actions/ThreadAction';
import { setRemovedFromThread, setThreadMembers, setThreadMembersError } from './actions/ThreadMembersAction';
import { Constants, MAXIMUM_INT64, MINIMUM_TYPING_INTERVAL_IN_MILLISECONDS } from './constants';
import { State } from './reducers';
import { User } from './reducers/ContosoClientReducers';
import { ClientChatMessage } from './reducers/MessagesReducer';
import RemoteStreamSelector from './RemoteStreamSelector';
import  pkg  from '../../package.json'
const messageSound = require('../assets/message.mp3');

let newMessages: string = "";
export let messagesCount = 0;
export let isTeamsChatHasHistory: boolean = false;
export let messageSender = "";
let resetMessagesCount: boolean = false;
let playChatSounds: boolean = true;
let hasBannedDevicesInit: boolean = false;
var tempList: Array<VideoDeviceInfo> = [];
let failCount = 0;

export let hasMicToggled: boolean = true; //we expect that the the Candidate's microphone is starting as enabled!

let remoteUserLocalSettingsProps: Array<IRemoteLocalSettingsProps> = [];

let selectedRemoteUserLocalSettingsProps: IRemoteLocalSettingsProps | undefined;

export const GetUserLocalSettingsProps = (userId: string) => {

    selectedRemoteUserLocalSettingsProps = undefined;

    if (remoteUserLocalSettingsProps.length > 0) {
        let settings = remoteUserLocalSettingsProps?.find((c) => c.userId === userId);

        if (settings) {
            selectedRemoteUserLocalSettingsProps = settings;

            console.log('Settings: userLocalSettingsProps:' + selectedRemoteUserLocalSettingsProps?.videoDevice);
        }
    }
    return selectedRemoteUserLocalSettingsProps;
};

export const SetUserLocalSettingsProps = (props: IRemoteLocalSettingsProps) => {
    console.log('Settings: props.camera:' + props.videoDevice);
    selectedRemoteUserLocalSettingsProps = {
        videoDeviceList: props.videoDeviceList,
        audioDeviceList: props.audioDeviceList,
        videoDevice: props.videoDevice,
        audioDevice: props.audioDevice,
        videoIndex: props.videoIndex,
        audioIndex: props.audioIndex,
        userId: props.userId
    }
};

export const resetNewMessages = (val: boolean) => {
    if (val) {
        resetMessagesCount = true;
        messagesCount = 0;
        isTeamsChatHasHistory = false;
        messageSender = "";
        newMessages = '';
        SetSpanIconNotification(messagesCount);
    }
    else {
        resetMessagesCount = false;
    }
};

export const toggleChatSound = (val: boolean) => {
    if (val) {
        playChatSounds = true;
    }
    else {
        playChatSounds = false;
    }
};

const SetSpanIconNotification = (messagesCount: number) => {
    if (messagesCount > 0 && !resetMessagesCount)
        newMessages = messagesCount.toString();
    else
        newMessages = '';

    var element = document.getElementById('spanIconBadge');
    if (element) element.innerHTML = newMessages;
}

const addUserToThread = (displayName: string) => async (dispatch: Dispatch, getState: () => State) => {
    let state: State = getState();
    if (state.thread.threadId === undefined) {
        console.error('Thread Id not created yet');
        return;
    }
    let threadId: string = state.thread.threadId;

    // get environment url from server
    let environmentUrl = await getEnvironmentUrl();

    if (environmentUrl === undefined) {
        console.error('unable to get environment url from server');
        return;
    }
    // create our user
    let userToken = await getToken();

    if (userToken === undefined) {
        console.error('unable to get a token');
        return;
    }

    const user = userToken.user as CommunicationUserIdentifier;

    let options: CommunicationTokenRefreshOptions = {
        token: userToken.token,
        tokenRefresher: () => refreshTokenAsync(user.communicationUserId),
        refreshProactively: true
    };

    let userAccessTokenCredentialNew = new AzureCommunicationTokenCredential(options);

    initVariables(getState);

    let chatClient = new ChatClient(environmentUrl, userAccessTokenCredentialNew);

    // set emoji for the user
    // setEmoji(user.communicationUserId, emoji);

    // subscribe for message, typing indicator, and read receipt
    let chatThreadClient = await chatClient.getChatThreadClient(threadId);

    subscribeForMessage(chatClient, dispatch, getState);
    subscribeForTypingIndicator(chatClient, dispatch);
    subscribeForReadReceipt(chatClient, chatThreadClient, dispatch);
    subscribeForChatParticipants(chatClient, user.communicationUserId, dispatch, getState);
    subscribeForTopicUpdated(chatClient, dispatch, getState);
    dispatch(setThreadId(threadId));
    dispatch(setContosoUser(user.communicationUserId, userToken.token, displayName));
    dispatch(setChatClient(chatClient));
    setShareUnshareScreen(false);

    await addThreadMemberHelper(
        threadId,
        {
            identity: user.communicationUserId,
            token: userToken.token,
            displayName: displayName,
            memberRole: 'User'
        },
        dispatch
    );

    await getThreadInformation(chatClient, dispatch, getState);
    await getMessages(chatClient, dispatch, getState);
};

const getMessagesHelper = async (chatThreadClient: ChatThreadClient): Promise<ChatMessage[] | undefined> => {
    try {
        let messages: ChatMessage[] = [];
        let getMessagesResponse = await chatThreadClient.listMessages({
            maxPageSize: PAGE_SIZE
        });

        let messages_temp = [];

        for await (let page of getMessagesResponse.byPage()) {
            for (const message of page) {
                messages_temp.push(message);
            }
        }

        while (true) {
            if (messages_temp === undefined) {
                console.error('Unable to get messages from server');
                return;
            }

            // filter and only return top 100 text messages
            messages.push(...messages_temp.filter((message) => message.type === 'text'));
            if (messages.length >= INITIAL_MESSAGES_SIZE) {
                return messages.slice(0, INITIAL_MESSAGES_SIZE);
            }
            // if there is no more messages
            break;
        }

        return messages.slice(0, INITIAL_MESSAGES_SIZE);
    } catch (error) {
        console.error('Failed at getting messages, Error: ', error);
        return;
    }
};

const getMessages = async (chatClient: ChatClient, dispatch: Dispatch, getState: () => State) => {
    let state: State = getState();
    if (chatClient === undefined) {
        console.error('Chat Client not created yet');
        return;
    }
    let threadId = state.thread.threadId;
    if (threadId === undefined) {
        console.error('Thread Id not created yet');
        return;
    }
    let messages = await getMessagesHelper(await chatClient.getChatThreadClient(threadId));
    if (messages === undefined) {
        console.error('unable to get messages');
        return;
    }

    const reversedClientChatMessages: ClientChatMessage[] = messages
        .map((message) => convertToClientChatMessage(message))
        .reverse();

    return dispatch(setMessages(reversedClientChatMessages));
};

const getThreadInformation = async (chatClient: ChatClient, dispatch: Dispatch, getState: () => State) => {
    let state: State = getState();
    if (chatClient === undefined) {
        console.error('Chat Client not created yet');
        return;
    }
    let threadId = state.thread.threadId;
    if (threadId === undefined) {
        console.error('Thread Id not created yet');
        return;
    }

    let chatThreadClient;
    let iteratableParticipants;
    //let topic;

    try {
        chatThreadClient = chatClient.getChatThreadClient(threadId);
        iteratableParticipants = chatThreadClient.listParticipants();
    } catch (error) {
        console.error(error);
        dispatch(setThreadMembersError(true));
    }

    let chatParticipants = [];
    // This is just to get all of the members in a chat. This is not performance as we're not using paging
    if (!iteratableParticipants) {
        console.error('unable to resolve chat participant iterator');
        return; // really we need to alert that there was an error?
    }

    for await (const page of iteratableParticipants.byPage()) {
        for (const chatParticipant of page) {
            chatParticipants.push(chatParticipant);
        }
    }

    if (chatParticipants.length === 0) {
        console.error('unable to get members in the thread');
        return;
    }

    // remove undefined display name chat participants
    const validChatParticipants = chatParticipants.filter(
        (chatParticipant) => chatParticipant.displayName !== undefined && chatParticipant.id !== undefined
    );

    // get the emojis for the new participants
    let users = state.contosoClient.users;
    //for (var i = 0; i < chatParticipants.length; i++) {
    //    var threadMember = chatParticipants[i];
    //    var identity = (threadMember.id as CommunicationUserIdentifier).communicationUserId;
    //    var user = users[identity];
    //    if (user == null) {
    //        var serverUser = await getEmoji(identity);
    //        if (serverUser !== undefined) {
    //            users[identity] = { emoji: serverUser.emoji };
    //        }
    //    }
    //}

    const properties = await chatThreadClient?.getProperties();

    if (!properties) {
        console.error('no chat thread properties');
        return;
    }

    dispatch(setThreadId(threadId));
    dispatch(setThreadTopicName(properties.topic));
    dispatch(setContosoUsers(users));
    dispatch(setThreadMembers(validChatParticipants));
};

const addThreadMemberHelper = async (threadId: string, user: User, dispatch: any) => {
    try {
        const urlParams = new URLSearchParams(window.location.search.substring(1));
        const moderatorId = urlParams.get('moderatorId');
        let body = {
            id: user.identity,
            displayName: user.displayName,
            isLocked: IsCandidateMode(),
            moderatorId: moderatorId
        };
        let addMemberRequestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        };

        await fetch('/addUser/' + threadId, addMemberRequestOptions).then(
            (response) => {
                if (response.ok) {
                    return true;
                } else {
                    return false;
                }
            },
            (error) => {
                console.error(error);
            }
        );

    } catch (error) {
        console.error('Failed at adding thread member, Error: ', error);
    }
};
const pingConnectedUser = async (userId: string, threadId: string) => {
    try {
        const request = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };
        await fetch('/PingForCandidate/' + userId + '/' + threadId, request);
    } catch (error) {
        console.error(error);
    }
}

const pingAndReconnectConnectedUser = async (userId: string, threadId: string, endCallHandler: () => void) => {
    try {
        const request = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };
        var result = await fetch('/PingForCandidate/' + userId + '/' + threadId, request);

        if (!result.ok) {
            try {
                const urlParams = new URLSearchParams(window.location.search.substring(1));
                const moderatorId = urlParams.get('moderatorId');

                const request = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                };
                var reconnectResult = await fetch('/TryToReconnectCandidate/' + userId + '/' + threadId + '/' + moderatorId, request);
                if (!reconnectResult.ok) {
                    failCount++;
                    if (failCount >= 4) {
                        endCallHandler();
                    }
                }
                else {
                    failCount = 0;
                }
            }
            catch (error) {
                console.error(error);
            }

        }
    }
    catch (error) {
        console.error(error);
    }
}

const subscribeForTypingIndicator = async (chatClient: ChatClient, dispatch: Dispatch) => {
    await chatClient.startRealtimeNotifications();
    chatClient.on('typingIndicatorReceived', async (event) => {
        const fromId = (event.sender as CommunicationUserKind).communicationUserId;
        const typingNotification = {
            from: fromId,
            originalArrivalTime: event.receivedOn,
            recipientId: (event.recipient as CommunicationUserKind).communicationUserId,
            threadId: event.threadId,
            version: event.version
        };
        dispatch(setTypingNotifications(fromId, typingNotification));
    });
};

const IsTeamsChatHasHistory = async () => {

    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const threadId = urlParams.get(URLOptionsConstants.THREADID);

    let isTeamsChatHasHistoryOptions = {
        method: 'POST'
    };

    if (threadId) {
        await fetch('/IsTeamsChatHasHistory/' + threadId, isTeamsChatHasHistoryOptions).then(
            (response) => {
                if (response.ok) {
                    isTeamsChatHasHistory = true;
                } else {
                    isTeamsChatHasHistory = false;
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }
};
const UnreadMessageCount = async () => {

    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const threadId = urlParams.get(URLOptionsConstants.THREADID);

    let UnreadMessageCountOptions = {
        method: 'POST'
    };

    if (threadId) {
        try {

            let response = await fetch('/UnreadMessageCount/' + threadId, UnreadMessageCountOptions);
            var msgcount = (await response.text().then((msgCount) => msgCount));
            messagesCount += parseInt(msgcount);
        } catch (error) {
            console.error(error);

        }
    }
};

const initVariables = async (getState: () => State) => {
    let state: State = getState();
    let messages: ClientChatMessage[] = state.chat.messages !== undefined ? state.chat.messages : [];
    
    if (IsCentralScreenMode())
        IsTeamsChatHasHistory();

    messagesCount = messages.length;

    if (IsProctorMode() || IsInterlocutorMode()) {
        await UnreadMessageCount();
    }


    SetSpanIconNotification(messagesCount);
};

const subscribeForMessage = async (chatClient: ChatClient, dispatch: Dispatch, getState: () => State) => {
    await chatClient.startRealtimeNotifications();
    chatClient.on('chatMessageReceived', async (event) => {
        let state: State = getState();
        let messages: ClientChatMessage[] = state.chat.messages !== undefined ? state.chat.messages : [];

        if (!isUserMatchingIdentity(event.sender, state.contosoClient.user.identity)) {
            const clientChatMessage = {
                sender: event.sender,
                id: event.id,
                senderDisplayName: event.senderDisplayName,
                createdOn: event.createdOn,
                content: { message: event.message }
            };

            messages.push(clientChatMessage);


            dispatch(setMessages(messages.sort(compareMessages)));

            messageSender = event.senderDisplayName;
            if (IsHiddenUser(messageSender)) {

                if (IsCandidateMode()) {
                    messagesCount += 1;
                    SetSpanIconNotification(messagesCount);
                    if (playChatSounds) {
                        let messageAudio = new Audio(messageSound);
                        messageAudio.play();
                        newMessageReceived();
                    }
                }
            }
            else {
                messagesCount += 1;
                SetSpanIconNotification(messagesCount);
                if (playChatSounds) {
                    let messageAudio = new Audio(messageSound);
                    messageAudio.play();
                    newMessageReceived();
                }
            }      
        }
    });
};
const newMessageReceived = () => {
    let input: HTMLElement = document.getElementById('newMessageReceived') as HTMLElement;

    if (input != null) {
        input.click();
    }
};

const subscribeForReadReceipt = async (
    chatClient: ChatClient,
    chatThreadClient: ChatThreadClient,
    dispatch: Dispatch
) => {
    await chatClient.startRealtimeNotifications();
    chatClient.on('readReceiptReceived', async (event) => {
        let receipts: ChatMessageReadReceipt[] = [];
        for await (let page of chatThreadClient.listReadReceipts().byPage()) {
            for (const receipt of page) {
                receipts.push(receipt);
            }
        }
        if (IsCentralScreenMode()) {
            resetNewMessages(true);
        }
        dispatch(setReceipts(receipts));
    });
};

const subscribeForChatParticipants = async (
    chatClient: ChatClient,
    identity: string,
    dispatch: Dispatch,
    getState: () => State
) => {
    chatClient.on('participantsRemoved', async (event: ParticipantsRemovedEvent) => {
        const state = getState();
        let participants: ChatParticipant[] = [];
        for (let chatParticipant of event.participantsRemoved) {
            // if you are in the list, remove yourself from the chat
            if (isUserMatchingIdentity(chatParticipant.id, identity)) {
                dispatch(setRemovedFromThread(true));
                return;
            }
        }

        const originalParticipants = state.threadMembers.threadMembers;
        for (var i = 0; i < originalParticipants.length; i++) {
            const participantId = (originalParticipants[i].id as CommunicationUserIdentifier).communicationUserId;
            if (
                event.participantsRemoved.filter((chatParticipant) => isUserMatchingIdentity(chatParticipant.id, participantId))
                    .length === 0
            ) {
                participants.push(originalParticipants[i]);
            }
        }

        dispatch(setThreadMembers(participants));
    });

    chatClient.on('participantsAdded', async (event: ParticipantsAddedEvent) => {
        const state = getState();
        let participants: ChatParticipant[] = [...state.threadMembers.threadMembers];

        // there is a chance that the participant added is you and so there is a chance that you can come in as a
        // new participant as well
        //const addedParticipants = event.participantsAdded.map((chatParticipant: ChatParticipant) => {
        //    return {
        //        id: chatParticipant.id,
        //        displayName: chatParticipant.displayName,
        //        shareHistoryTime: new Date(chatParticipant?.shareHistoryTime || new Date())
        //    };
        //});

        // add participants not in the list
        for (var j = 0; j < event.participantsAdded.length; j++) {
            const addedParticipant = event.participantsAdded[j];
            const id = (addedParticipant.id as CommunicationUserIdentifier).communicationUserId;
            if (
                participants.filter((participant: ChatParticipant) => isUserMatchingIdentity(participant.id, id)).length === 0
            ) {
                participants.push(addedParticipant);
            }
        }

        // also make sure we get the emojis for the new participants
        let users = Object.assign({}, state.contosoClient.users);
        dispatch(setContosoUsers(users));
        dispatch(setThreadMembers(participants));
    });
};

const subscribeForTopicUpdated = async (chatClient: ChatClient, dispatch: Dispatch, getState: () => State) => {
    chatClient.on('chatThreadPropertiesUpdated', async (e: ChatThreadPropertiesUpdatedEvent) => {
        const state = getState();
        let threadId = state.thread.threadId;

        if (!threadId) {
            console.error('no threadId set');
            return;
        }

        dispatch(setThreadTopicName(e.properties.topic));
    });
};

const getEnvironmentUrl = async () => {
    try {
        let getRequestOptions = {
            method: 'GET'
        };
        let response = await fetch('/getEnvironmentUrl', getRequestOptions);
        return (await response.text().then((environmentUrl) => environmentUrl)).toString();
    } catch (error) {
        console.error(error);
        return '';
    }
};

// Token Helper
const getToken = async () => {
    try {
        let getTokenRequestOptions = {
            method: 'POST'
        };
        let getTokenResponse = await fetch('/token', getTokenRequestOptions);
        return getTokenResponse.json().then((_responseJson) => _responseJson);
    } catch (error) {
        console.error('Failed at getting token, Error: ', error);
    }
};

const refreshTokenAsync = async (userIdentity: string): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        return fetch('/refreshTokenChat/' + userIdentity).then(
            (response) => {
                if (response.ok) {
                    resolve(response.json().then((json) => json.token));
                } else {
                    reject(new Error('error'));
                }
            },
            (error) => {
                reject(new Error(error.message));
            }
        );
    });
};

// Typing Notification Helper
const sendTypingNotificationHelper = async (chatThreadClient: ChatThreadClient) => {
    try {
        await chatThreadClient.sendTypingNotification();
    } catch (error) {
        console.error('Failed at sending typing notification, Error: ', error);
    }
};

const sendTypingNotification = () => async (dispatch: Dispatch, getState: () => State) => {
    let state: State = getState();
    let chatClient = state.contosoClient.chatClient;
    if (chatClient === undefined) {
        console.error('Chat Client not created yet');
        return;
    }
    let threadId = state.thread.threadId;
    if (threadId === undefined) {
        console.error('Thread Id not created yet');
        return;
    }
    await sendTypingNotificationHelper(await chatClient.getChatThreadClient(threadId));
};

const sendMessage = (messageContent: string) => async (dispatch: Dispatch, getState: () => State) => {
    let state: State = getState();
    let chatClient = state.contosoClient.chatClient;
    if (chatClient === undefined) {
        console.error('Chat Client not created yet');
        return;
    }
    let threadId = state.thread.threadId;
    if (threadId === undefined) {
        console.error('Thread Id not created yet');
        return;
    }
    let displayName = state.contosoClient.user.displayName;
    let userId = state.contosoClient.user.identity;

    // we use this client message id to have a local id for messages
    // if we fail to send the message we'll at least be able to show that the message failed to send on the client
    let clientMessageId = (Math.floor(Math.random() * MAXIMUM_INT64) + 1).toString(); //generate a random unsigned Int64 number
    let newMessage = createNewClientChatMessage(userId, displayName, clientMessageId, messageContent);

    let messages = getState().chat.messages;
    messages.push(newMessage);
    dispatch(setMessages(messages));

    await sendMessageHelper(
        await chatClient.getChatThreadClient(threadId),
        messageContent,
        displayName,
        clientMessageId,
        dispatch,
        getState
    );
};
export const setMicrophone = (mic: boolean) => {
    return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
        try {


            if (!IsCandidateMode()) {
                const urlParams = new URLSearchParams(window.location.search.substring(1));
                const userId = urlParams.get('proctorId');
                let ToggleMicrophoneOptions = {
                    method: 'POST'
                };
                if (userId) {
                    await fetch('/ToggleMicrophone/' + userId + '/' + mic, ToggleMicrophoneOptions).then(
                        (response) => {
                            if (response.ok) {
                                return true;
                            } else {
                                return false;
                            }
                        },
                        (error) => {
                            console.error(error);
                        }
                    );
                }
            }


            const state = getState();

            if (state === undefined || state.calls.call === undefined) {
                return;
            }

            if (!state.controls.mic) { //|| IsCandidateMode()) {
                await state.calls.call.unmute();
                hasMicToggled = true;
            }
            else {
                await state.calls.call.mute();
                hasMicToggled = false;
            }

            dispatch(setMic(mic)); // || IsCandidateMode()));


        } catch (e) {
            console.error(e);
        }
    };
};
const sendMessageHelper = async (
    chatThreadClient: ChatThreadClient,
    messageContent: string,
    displayName: string,
    clientMessageId: string,
    dispatch: Dispatch,
    getState: () => State
) => {
    // for real time messages we want to store it locally and render it and then sync it with the server message later
    // 1. send the message
    // 2. cache the message locally using the message.id
    // 3. when we get the server synced message we match with the message.id
    try {
        const messageResult = await chatThreadClient.sendMessage(
            { content: messageContent },
            { senderDisplayName: displayName }
        );
        const message: ChatMessage = await chatThreadClient.getMessage(messageResult.id);
        updateMessagesArray(dispatch, getState, convertToClientChatMessage(message, clientMessageId));

        if (IsCandidateMode()) {
            await sendChatNotificationCaution();
        }
    } catch (error) {
        console.error('Failed at getting messages, Error: ', error);
        let failedMessages = getState().chat.failedMessages;
        failedMessages.push(clientMessageId);
        setFailedMessages(failedMessages);

        const message = getState().chat.messages.filter((message) => message.clientMessageId === clientMessageId)[0];
        message.failed = true;
        updateMessagesArray(dispatch, getState, message);
    }
};

const sendChatNotificationCaution = async () => {

    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const threadId = urlParams.get(URLOptionsConstants.THREADID);

    let sendChatNotificationCautionOptions = {
        method: 'POST'
    };

    if (threadId) {
        await fetch('/SendChatNotificationCaution/' + threadId, sendChatNotificationCautionOptions).then(
            (response) => {
                if (response.ok) {
                    return true;
                } else {
                    return false;
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }
};

const updateMessagesArray = async (dispatch: Dispatch, getState: () => State, newMessage: ClientChatMessage) => {
    let state: State = getState();
    let messages: ClientChatMessage[] = state.chat.messages !== undefined ? state.chat.messages : [];

    // the message id is what we we get from the server when it is synced. There will be other server attributes
    // on the message but the id should be consistent.
    messages = messages.map((message: ClientChatMessage) => {
        return message.clientMessageId === newMessage.clientMessageId ? Object.assign({}, message, newMessage) : message;
    });
    dispatch(setMessages(messages.sort(compareMessages)));
};

export const setShareUnshareScreen = (shareScreen: boolean) => {
    return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
        const state = getState();

        if (state === undefined || state.calls.call === undefined) {
            console.error('state or state.controls.shareScreen is null');
            return;
        }

        try {
            if (!state.controls.shareScreen) {
                await state.calls.call.startScreenSharing();
            } else {
                await state.calls.call.stopScreenSharing();
            }

            dispatch(setShareScreen(shareScreen));        
        } catch (e) {
            console.error(e);
        }
    };
};

const subscribeToParticipant = (participant: RemoteParticipant, call: Call, dispatch: Dispatch): void => {
    const dominantParticipantCount = utils.isSafari()
        ? Constants.DOMINANT_PARTICIPANTS_COUNT_SAFARI
        : Constants.DOMINANT_PARTICIPANTS_COUNT;
    const remoteStreamSelector = RemoteStreamSelector.getInstance(dominantParticipantCount, dispatch);

    subscribeToParticipantStream(participant, call, dispatch, remoteStreamSelector);

    participant.on('stateChanged', () => {
        remoteStreamSelector.participantStateChanged(
            utils.getId(participant.identifier),
            participant.displayName ?? '',
            participant.state,
            !participant.isMuted,
            participant.videoStreams[0].isAvailable
        );
        dispatch(setParticipants([...call.remoteParticipants.values()]));
    });

    participant.on('isMutedChanged', () => {
        remoteStreamSelector.participantAudioChanged(utils.getId(participant.identifier), !participant.isMuted);
    });

    participant.on('isSpeakingChanged', () => {
        dispatch(setParticipants([...call.remoteParticipants.values()]));
    });

    participant.videoStreams.map((videoStream) => {
        if (videoStream.mediaStreamType === 'ScreenSharing') {
            videoStream.on('isAvailableChanged', () => {
                if (videoStream.isAvailable) {
                    dispatch(addScreenShareStream(videoStream, participant));
                } else {
                    dispatch(removeScreenShareStream(videoStream, participant));
                }
                dispatch(setParticipants([...call.remoteParticipants.values()]));
            });
        }
        else {
            videoStream.on('isAvailableChanged', () => {
                remoteStreamSelector.participantVideoChanged(utils.getId(participant.identifier), videoStream.isAvailable);
                dispatch(setParticipants([...call.remoteParticipants.values()]));
            });

        }
    });


};
const subscribeToParticipantStream = (participant: RemoteParticipant, call: Call, dispatch: Dispatch, remoteStreamSelector: RemoteStreamSelector): void => {
    if (participant.videoStreams[1].mediaStreamType === 'ScreenSharing') {

        if (participant.videoStreams[1].isAvailable) {
            dispatch(addScreenShareStream(participant.videoStreams[1], participant));
        } else {
            dispatch(removeScreenShareStream(participant.videoStreams[1], participant));
        }

    }
    else {

        remoteStreamSelector.participantVideoChanged(utils.getId(participant.identifier), participant.videoStreams[0].isAvailable);
        dispatch(setParticipants([...call.remoteParticipants.values()]));

    }
};
export const SetSelectedMicrophone = (val: number): void => {
    if (val > -1) {
        let urlparams = window.location.search.substring(1);
        if (urlparams.includes(URLOptionsConstants.MICROPHONEINDEX)) {
            var url = new URL(window.location.href);
            var search_params = url.searchParams;
            search_params.set(URLOptionsConstants.MICROPHONEINDEX, val.toString());
            url.search = search_params.toString();
            window.history.pushState({}, document.title, url.toString());
        }
        else {
            if (urlparams.includes('?') || urlparams.includes('&'))
                window.history.pushState({}, document.title, window.location.href + '&' + URLOptionsConstants.MICROPHONEINDEX + '=' + val.toString());
            else
                window.history.pushState({}, document.title, window.location.href + '?' + URLOptionsConstants.MICROPHONEINDEX + '=' + val.toString());
        }
    }
}

export const SetSelectedCamera = (val: number): void => {
    if (val > -1) {
        let urlparams = window.location.search.substring(1);
        if (urlparams.includes(URLOptionsConstants.CAMERAINDEX)) {
            var url = new URL(window.location.href);
            var search_params = url.searchParams;
            search_params.set(URLOptionsConstants.CAMERAINDEX, val.toString());
            url.search = search_params.toString();
            window.history.pushState({}, document.title, url.toString());
        }
        else {
            if (urlparams.includes('?') || urlparams.includes('&'))
                window.history.pushState({}, document.title, window.location.href + '&' + URLOptionsConstants.CAMERAINDEX + '=' + val.toString());
            else
                window.history.pushState({}, document.title, window.location.href + '?' + URLOptionsConstants.CAMERAINDEX + '=' + val.toString());
        }
    }
}

export const GetSelectedMicrophone = (): number => {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const selectedMicrophone = urlParams.get(URLOptionsConstants.MICROPHONEINDEX);
    if (selectedMicrophone)
        return parseInt(selectedMicrophone);
    else
        return -1;
}

export const GetSelectedCamera = (): number => {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const selectedCamera = urlParams.get(URLOptionsConstants.CAMERAINDEX);
    if (selectedCamera)
        return parseInt(selectedCamera);
    else
        return -1;
}

const updateBannedDeviceList = async (list: Array<VideoDeviceInfo>, hasInit: boolean): Promise<Array<VideoDeviceInfo>> => {
    if (!hasBannedDevicesInit) {
        tempList = list;
        hasBannedDevicesInit = hasInit;

        await GetBlockedDevices().then((blockeddevices) => {
            if (tempList.length > 0) {
                if (blockeddevices) {
                    if (blockeddevices.length > 0) {
                        tempList = tempList.filter(ar => !blockeddevices.find(rm => (rm.toLowerCase() === ar.name.toLowerCase() || (ar.name.toLowerCase().indexOf(rm.toLowerCase()) >= 0))));
                    }
                }
            }
        });
    }

    return tempList;
};

const updateAudioDevices = async (
    deviceManager: DeviceManager,
    dispatch: Dispatch,
    getState: () => State
): Promise<void> => {
    const microphoneList: AudioDeviceInfo[] = await deviceManager.getMicrophones();
    dispatch(setAudioDeviceList(microphoneList));
    const state = getState();
    if (state.devices.audioDeviceInfo === undefined && microphoneList.length > 0) {
        dispatch(setAudioDeviceInfo(microphoneList[0]));
        deviceManager.selectMicrophone(microphoneList[0]);
    } else if (
        state.devices.audioDeviceInfo &&
        !utils.isSelectedAudioDeviceInList(state.devices.audioDeviceInfo, microphoneList)
    ) {
        deviceManager.selectMicrophone(state.devices.audioDeviceInfo);
    }
};

const updateVideoDevices = async (
    deviceManager: DeviceManager,
    dispatch: Dispatch,
    getState: () => State
): Promise<void> => {
    var cameraList: VideoDeviceInfo[] = await deviceManager.getCameras();

    if (IsCandidateMode())
        cameraList = await updateBannedDeviceList(cameraList, true);

    dispatch(setVideoDeviceList(cameraList));

    const state = getState();

    if (state.devices.videoDeviceList.length > 0) {
        if (state.devices.videoDeviceList.length < GetSelectedCamera()) {
            dispatch(setVideoDeviceInfo(cameraList[0]));
        }
        else {
            let i: number = 0;
            state.devices.videoDeviceList.forEach((data) => {
                if (i === 0 || i === GetSelectedCamera()) {
                    dispatch(setVideoDeviceInfo(data));
                }
                i++;
            });
        }
    } else if (state.devices.videoDeviceInfo === undefined) {
        dispatch(setVideoDeviceInfo(cameraList[0]));
    } else if (
        state.devices.videoDeviceInfo &&
        !utils.isSelectedVideoDeviceInList(state.devices.videoDeviceInfo, cameraList)
    ) {
        dispatch(setVideoDeviceInfo(state.devices.videoDeviceInfo));
    }
};

const subscribeToDeviceManager = async (
    deviceManager: DeviceManager,
    dispatch: Dispatch,
    getState: () => State
): Promise<void> => {
    // listen for any new events
    deviceManager.on('videoDevicesUpdated', async () => {
        updateVideoDevices(deviceManager, dispatch, getState);
    });

    deviceManager.on('audioDevicesUpdated', async () => {
        updateAudioDevices(deviceManager, dispatch, getState);
    });

    deviceManager.askDevicePermission({ audio: true, video: true }).then((e: DeviceAccess) => {
        if (e.audio !== undefined) {
            if (e.audio) {
                dispatch(setMicrophonePermission('Granted'));

                updateAudioDevices(deviceManager, dispatch, getState);
            } else {
                dispatch(setMicrophonePermission('Denied'));
            }
        }

        if (e.video !== undefined) {
            if (e.video) {
                dispatch(setCameraPermission('Granted'));
                updateVideoDevices(deviceManager, dispatch, getState);
            } else {
                dispatch(setCameraPermission('Denied'));
            }
        }
    });
};

export const updateDevices = () => {
    return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
        const state = getState();
        const deviceManager = state.devices.deviceManager;

        if (deviceManager == null) {
            console.error('no device manager available');
            return;
        }

        var cameraList: VideoDeviceInfo[] = await deviceManager.getCameras();

        if (IsCandidateMode())
            cameraList = await updateBannedDeviceList(cameraList, true);

        dispatch(setVideoDeviceList(cameraList));

        const microphoneList: AudioDeviceInfo[] = await deviceManager.getMicrophones();

        dispatch(setAudioDeviceList(microphoneList));
    };
};

export const registerToCallAgent = (
    userId: string,
    callAgent: CallAgent,
    callEndedHandler: (reason: CallEndReason) => void
) => {
    return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
        setLogLevel('verbose');
        setUserId(userId);
        setCallAgent(callAgent);
        const urlParams = new URLSearchParams(window.location.search.substring(1));
        const threadId = urlParams.get(URLOptionsConstants.THREADID);
        callAgent.on('callsUpdated', (e: { added: Call[]; removed: Call[] }): void => {

            e.added.forEach((addedCall) => {
                console.log(`Call added : Call Id = ${addedCall.id}`);

                const state = getState();
                if (state.calls.call && addedCall.direction === 'Incoming') {
                    addedCall.hangUp();
                    return;
                }
                dispatch(callAdded(addedCall));

                if (ShouldUserBeMuted()) {
                    addedCall.muteIncomingAudio();
                }

                addedCall.on('stateChanged', (): void => {
                    dispatch(setCallState(addedCall.state));
                });

                dispatch(setCallState(addedCall.state));

                addedCall.on('isScreenSharingOnChanged', (): void => {
                    dispatch(setShareScreen(addedCall.isScreenSharingOn));
                });

                dispatch(setShareScreen(addedCall.isScreenSharingOn));

                if (threadId)
                    SignalRUserConnect(threadId, userId);

                // if remote participants have changed, subscribe to the added remote participants
                addedCall.on('remoteParticipantsUpdated', (ev): void => {

                    // for each of the added remote participants, subscribe to events and then just update as well in case the update has already happened
                    const state = getState();
                    if (!IsSecondaryStream()) {
                        ev.added.forEach((addedRemoteParticipant) => {

                            const dominantParticipantCount = utils.isSafari()
                                ? Constants.DOMINANT_PARTICIPANTS_COUNT_SAFARI
                                : Constants.DOMINANT_PARTICIPANTS_COUNT;
                            const remoteStreamSelector = RemoteStreamSelector.getInstance(dominantParticipantCount, dispatch);
                            remoteStreamSelector.participantStateChanged(
                                utils.getId(addedRemoteParticipant.identifier),
                                addedRemoteParticipant.displayName ?? '',
                                addedRemoteParticipant.state,
                                !addedRemoteParticipant.isMuted,
                                addedRemoteParticipant.videoStreams[0].isAvailable
                            );

                            if (IsInterlocutorMode() || IsProctorMode())
                                requestCandidateSettings(threadId, utils.getId(addedRemoteParticipant.identifier));


                            dispatch(setParticipants([...addedCall.remoteParticipants.values()]));

                            subscribeToParticipant(addedRemoteParticipant, addedCall, dispatch);
                            dispatch(setParticipants([...state.calls.remoteParticipants, addedRemoteParticipant]));
                        });
                    }

                    // We don't use the actual value we are just going to reset the remoteParticipants based on the call
                    if (ev.removed.length > 0) {
                        dispatch(setParticipants([...addedCall.remoteParticipants.values()]));

                        ev.removed.forEach((removedParticipant) => {
                            let partiticipantId = utils.getId(removedParticipant.identifier);
                            let checkUserSettings = remoteUserLocalSettingsProps?.find((c) => c.userId === partiticipantId);

                            if (checkUserSettings) {
                                const index = remoteUserLocalSettingsProps.indexOf(checkUserSettings);
                                if (index > -1) {
                                    remoteUserLocalSettingsProps.splice(index, 1);
                                }
                            }
                        });

                    }
                });
                dispatch(setParticipants([...state.calls.remoteParticipants]));
            });
            e.removed.forEach((removedCall) => {
                const state = getState();
                if (state.calls.call && state.calls.call === removedCall) {
                    dispatch(callRemoved(removedCall, state.calls.group));
                    if (removedCall.callEndReason && removedCall.callEndReason.code !== 0) {
                        removedCall.callEndReason && callEndedHandler(removedCall.callEndReason);
                    }
                }
            });
        });
    };
};

export const initCallClient = (unsupportedStateHandler: () => void) => {
    return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
        let callClient;

        // check if chrome on ios OR firefox browser
        if (utils.isOnIphoneAndNotSafari() || utils.isUnsupportedBrowser()) {
            unsupportedStateHandler();
            return;
        }
        else if (!HasCallMode()) {
            unsupportedStateHandler();
            return;
        }
        try {
            const urlParams = new URLSearchParams(window.location.search.substring(1));
            const callClientOptions = {
                diagnostics: {
                    appName: "TeamsReactCalling",
                    appVersion: pkg.version,
                    tags: ["CallMode" + urlParams.get('callMode')]
                }
            };
            callClient = new CallClient(callClientOptions);
        } catch (e) {
            unsupportedStateHandler();
            return;
        }

        if (!callClient) {
            return;
        }

        const deviceManager: DeviceManager = await callClient.getDeviceManager();

        dispatch(setCallClient(callClient));
        dispatch(setDeviceManager(deviceManager));
        subscribeToDeviceManager(deviceManager, dispatch, getState);
    };
};

// what does the forEveryone parameter really mean?
export const endCall = async (state: State, options: HangUpOptions, userId: string): Promise<void> => {
    if (IsCandidateMode()) {
        try {
            let disconnectCandidateOptions = {
                method: 'POST'
            };
            let threadId = state.thread.threadId;
            await fetch('/disconnect/' + threadId + '/' + userId, disconnectCandidateOptions);
        } catch (error) {
            console.error('Failed at getting token, Error: ', error);
        }
    }

    if (state.calls.call !== undefined)
    {
        await state.calls.call.hangUp(options).catch((e: CommunicationServicesError) => {
            console.error(e);
        });
    }
};

export const joinGroup = async (
    callAgent: CallAgent,
    context: GroupCallLocator,
    callOptions: JoinCallOptions
): Promise<void> => {
    try {
        await callAgent.join(context, callOptions);
    } catch (e) {
        console.log('Failed to join a call', e);
        return;
    }
};

export const addParticipant = async (call: Call, user: CommunicationUserKind): Promise<void> => {
    await call.addParticipant(user);
};

export const removeParticipant = async (call: Call, user: CommunicationUserKind): Promise<void> => {
    await call.removeParticipant(user).catch((e: CommunicationServicesError) => {
        console.error(e);
    });
};

const createThreadHelper = async () => {
    try {
        return await utils.CreateChatThread()
    } catch (error) {
        console.error(error);
        return '';
    }
};
const createThread = async (): Promise<string> => {
    let threadId = await createThreadHelper();
    if (threadId === undefined) {
        return 'unable to generate a new chat thread';
    }
    return threadId;
};
const addThreadMember = () => async (dispatch: Dispatch, getState: () => State) => {
    let state: State = getState();
    let user = state.contosoClient.user;
    let threadId = state.thread.threadId;

    if (threadId === undefined) {
        console.error('Thread Id not created yet');
        return;
    }
    await addThreadMemberHelper(
        threadId,
        {
            identity: user.identity,
            token: user.token,
            displayName: user.displayName,
            memberRole: 'User'
        },
        dispatch
    );
};
const getThreadMembers = () => async (dispatch: Dispatch, getState: () => State) => {
    let state: State = getState();
    let chatClient = state.contosoClient.chatClient;
    if (chatClient === undefined) {
        console.error('Chat Client not created yet');
        return;
    }
    let threadId = state.thread.threadId;
    if (threadId === undefined) {
        console.error('Thread Id not created yet');
        return;
    }
    let chatThreadClient = await chatClient.getChatThreadClient(threadId);

    try {
        let threadMembers = [];
        for await (let page of chatThreadClient.listParticipants().byPage()) {
            for (const threadMember of page) {
                threadMembers.push(threadMember);
            }
        }
        dispatch(setThreadMembers(threadMembers));
    } catch (error) {
        console.error('Failed at getting members, Error: ', error);
        dispatch(setThreadMembersError(true));
    }
};
const sendReadReceipt = (messageId: string) => async (dispatch: Dispatch, getState: () => State) => {
    // This is sent when we get focus to this tab and see this message
    let state: State = getState();
    let chatClient = state.contosoClient.chatClient;
    if (chatClient === undefined) {
        console.error('Chat Client not created yet');
        return;
    }
    let threadId = state.thread.threadId;
    if (threadId === undefined) {
        console.error('Thread Id not created yet');
        return;
    }
    if (!IsCandidateMode()) {
        await sendReadReceiptHelper(await chatClient.getChatThreadClient(threadId), messageId);
    }
};
const updateTypingUsers = () => async (dispatch: Dispatch, getState: () => State) => {
    let typingUsers = [];
    let state: State = getState();
    let typingNotifications = state.chat.typingNotifications;
    for (let id in typingNotifications) {
        let typingNotification = typingNotifications[id];
        if (!typingNotification.originalArrivalTime) {
            continue;
        }
        if (shouldDisplayTyping(typingNotification.originalArrivalTime)) {
            let threadMember = state.threadMembers.threadMembers.find((threadMember) =>
                isUserMatchingIdentity(threadMember.id, id)
            );
            if (threadMember) {
                typingUsers.push(threadMember);
            }
        }
    }
    dispatch(setTypingUsers(typingUsers));
};
const isValidThread = (threadId: string) => async (dispatch: Dispatch) => {
    try {
        let validationRequestOptions = { method: 'GET' };
        let validationResponse = await fetch('/isValidThread/' + threadId, validationRequestOptions);
        if (validationResponse.status === 200) {
            dispatch(setThreadId(threadId));
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return error;
    }
};
const removeThreadMemberByUserId = (userId: string) => async (dispatch: Dispatch, getState: () => State) => {
    let state: State = getState();
    let chatClient = state.contosoClient.chatClient;
    let threadId = state.thread.threadId;
    if (chatClient === undefined) {
        console.error("Chat client doesn't created yet");
        return;
    }
    if (threadId === undefined) {
        console.error('Thread Id not created yet');
        return;
    }
    let chatThreadClient = await chatClient.getChatThreadClient(threadId);
    try {
        await chatThreadClient.removeParticipant({
            communicationUserId: userId
        });
    } catch (error) {
        console.error(error);
    }
};
const updateThreadTopicName = async (
    chatClient: ChatClient,
    threadId: string,
    topicName: string,
    setIsSavingTopicName: React.Dispatch<boolean>
) => {
    const chatThreadClient = await chatClient.getChatThreadClient(threadId);
    updateThreadTopicNameHelper(chatThreadClient, topicName, setIsSavingTopicName);
};
const updateThreadTopicNameHelper = async (
    chatThreadClient: ChatThreadClient,
    topicName: string,
    setIsSavingTopicName: React.Dispatch<boolean>
) => {
    try {
        await chatThreadClient.updateTopic(topicName);
        setIsSavingTopicName(false);
    } catch (error) {
        console.error('Failed at updating thread property, Error: ', error);
    }
};
const shouldDisplayTyping = (lastReceivedTypingEventDate: number) => {
    let currentDate = new Date();
    let timeSinceLastTypingNotificationMs = currentDate.getTime() - lastReceivedTypingEventDate;
    return timeSinceLastTypingNotificationMs <= MINIMUM_TYPING_INTERVAL_IN_MILLISECONDS;
};
const sendReadReceiptHelper = async (chatThreadClient: ChatThreadClient, messageId: string) => {
    let postReadReceiptRequest: SendReadReceiptRequest = {
        chatMessageId: messageId
    };
    await chatThreadClient.sendReadReceipt(postReadReceiptRequest);
};

const DisableAutoGain = async () => {
    const constraints = {
        audio: true
    };
    disableAutogain(constraints);

    var userMedia = await navigator.mediaDevices.getUserMedia(constraints)

    var listAudioTracks = userMedia.getAudioTracks();
    var currentConstraints = listAudioTracks[0].getConstraints();

    console.log("Constraints is set to", currentConstraints);
}

const setConstraint = (constraint: MediaTrackConstraints, name: string, value: boolean) => {

    constraint['autoGainControl'] = value;
}
const disableAutogain = (constraints: MediaStreamConstraints) => {
    console.log("Automatically unsetting gain!", constraints);
    if (constraints && constraints.audio) {
        if (typeof constraints.audio !== "object") {
            constraints.audio = {};
        }

        setConstraint(constraints.audio, "autoGainControl", false);
    }
}

const ImageAnalyze = async (base64Image: string, threadId: string) => {
    try {
        let options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ StringBase: base64Image, ThreadId: threadId })
        };
        await fetch('/AnalyzeImage/' + threadId, options);
    } catch (error) {
        return error;
    }
}

export {
    sendMessage,
    getMessages,
    createThread,
    addThreadMember,
    getThreadMembers,
    addUserToThread,
    removeThreadMemberByUserId,
    sendReadReceipt,
    sendTypingNotification,
    updateTypingUsers,
    isValidThread,
    updateThreadTopicName,
    pingConnectedUser,
    pingAndReconnectConnectedUser,
    DisableAutoGain,
    ImageAnalyze
};

/* SignalR */
export const SignalRUserConnect = async (threadId: string, userId: string): Promise<void> => {
    if (connection.state === signalR.HubConnectionState.Connected) {

        if (IsCandidateMode() || IsSecondaryStream()) {

            await connection.invoke("Connect", userId, threadId, false);
        }
        else {
            await connection.invoke("Connect", userId, threadId, true);
        }
        console.log("SignalR: Connected with connectionid: " + connection.connectionId + ", mode iscandidate: " + IsCandidateMode() + "mode isSecondCamera:" + IsSecondaryStream() + ", status: " + connection.state);
    }
};

export const SignalRUserDisconnect = async (threadId: string, userId: string): Promise<void> => {
    if (connection.state === signalR.HubConnectionState.Connected) {
        await connection.invoke("Disconnect", threadId, userId);
        console.log("SignalR:userId " + userId + " Is Disconnected ");
    }
};

export const toggleCandidateMicrophone = async (threadId: string | null, userid: string | null): Promise<void> => {
    if (IsInterlocutorMode() || IsProctorMode()) {
        try {
            let candidate = await connection.invoke("GetUserByUserId", threadId, userid);
            let randonumber = Math.floor(Math.random() * (100000 - 10000)) + 10000;

            if (candidate) {
                let usercomm = '{"ConnectionID":"' + candidate.connectionId + '","UserId":"' + candidate.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.ToggleMicrophone + ',"Command":""}';
                await connection.invoke("SendToUser", usercomm);
            }
        } catch (error) {
            console.error('SignalR:Failed to mute Candidate, Error: ', error);
        }
    }
};

export const toggleCandidateCamera = async (threadId: string | null, userid: string | null): Promise<void> => {
    if (IsInterlocutorMode() || IsProctorMode()) {
        try {
            let candidate = await connection.invoke("GetUserByUserId", threadId, userid);
            let randonumber = Math.floor(Math.random() * (100000 - 10000)) + 10000;

            if (candidate || candidate !== 'undefined') {
                let usercomm = '{"ConnectionID":"' + candidate.connectionId + '","UserId":"' + candidate.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.ToggleCamera + ',"Command":""}';

                await connection.invoke("SendToUser", usercomm);
            }
        } catch (error) {
            console.error('SignalR:Failed to toggle the camera state, Error: ', error);
        }
    }
};
export const refreshCandidatePage = async (threadId: string | null, userid: string | null): Promise<void> => {
    if (IsInterlocutorMode() || IsProctorMode()) {
        try {
            let candidate = await connection.invoke("GetUserByUserId", threadId, userid);
            let randonumber = Math.floor(Math.random() * (100000 - 10000)) + 10000;

            if (candidate || candidate !== 'undefined') {
                let usercomm = '{"ConnectionID":"' + candidate.connectionId + '","UserId":"' + candidate.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.RefreshCandidatePage + ',"Command":""}';

                await connection.invoke("SendToUser", usercomm);
            }
        } catch (error) {
            console.error('SignalR:Failed to refresh candidate page, Error: ', error);
        }
    }
};

export const triggerVolumeUp = async (threadId: string | null, userid: string | null): Promise<void> => {
    if (IsInterlocutorMode() || IsProctorMode()) {
        try {
            let candidate = await connection.invoke("GetUserByUserId", threadId, userid);
            let randonumber = Math.floor(Math.random() * (100000 - 10000)) + 10000;

            if (candidate) {
                let usercomm = '{"ConnectionID":"' + candidate.connectionId + '","UserId":"' + candidate.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.IncreaseVolume + ',"Command":""}';

                await connection.invoke("SendToUser", usercomm);
            }
        } catch (error) {
            console.error('SignalR:Failed to trigger volume up, Error: ', error);
        }
    }
};

export const triggerVolumeDown = async (threadId: string | null, userid: string | null): Promise<void> => {
    if (IsInterlocutorMode() || IsProctorMode()) {
        try {
            let candidate = await connection.invoke("GetUserByUserId", threadId, userid);
            let randonumber = Math.floor(Math.random() * (100000 - 10000)) + 10000;

            if (candidate) {
                let usercomm = '{"ConnectionID":"' + candidate.connectionId + '","UserId":"' + candidate.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.DecreaseVolume + ',"Command":""}';

                await connection.invoke("SendToUser", usercomm);
            }
        } catch (error) {
            console.error('SignalR:Failed to trigger volume down, Error: ', error);
        }
    }
};


export const toggleCandidateScreenSharing = async (threadId: string | null, userid: string | null): Promise<void> => {
    if (IsInterlocutorMode() || IsProctorMode()) {
        try {
            let candidate = await connection.invoke("GetUserByUserId", threadId, userid);
            let randonumber = Math.floor(Math.random() * (100000 - 10000)) + 10000;

            if (candidate) {
                let usercomm = '{"ConnectionID":"' + candidate.connectionId + '","UserId":"' + candidate.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.ToggleScreenSharing + ',"Command":""}';

                await connection.invoke("SendToUser", usercomm);
            }
        } catch (error) {
            console.error('SignalR:Failed to toggle the screen sharing, Error: ', error);
        }
    }
};

export const requestCandidateSettings = async (threadId: string | null, userid: string | null): Promise<void> => {
    if (IsInterlocutorMode() || IsProctorMode()) {
        try {
            let candidate = await connection.invoke("GetUserByUserId", threadId, userid);
            let randonumber = Math.floor(Math.random() * (100000 - 10000)) + 10000;

            if (candidate) {
                let usercomm = '{"ConnectionID":"' + candidate.connectionId + '","UserId":"' + candidate.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.RequestSettings + ',"Command":""}';

                await connection.invoke("SendToUser", usercomm);
            }
        } catch (error) {
            console.error('SignalR:Failed to requestCandidateSettings, Error: ', error);
        }
    }
};

export const responseCandidateSettings = async (threadId: string | null): Promise<void> => {
    if (IsCandidateMode() || IsSecondaryStream()) {
        try {
            let user = await connection.invoke("GetUserByThreadId", threadId, true);
            let randonumber = Math.floor(Math.random() * (100000 - 10000)) + 10000;
            if (user) {
                var localsettings = UserLocalSettings();
                console.log('Settings: localsettings:' + localsettings.videoDevice);
                let settings = JSON.stringify(localsettings);
                settings = settings.toString().replace(/"/g, "'");
                let usercomm = '{"ConnectionID":"' + user.connectionId + '","UserId":"' + user.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.ResponseSettings + ',"Command":"' + settings + '"}';
                await connection.invoke("SendToUser", usercomm);
            }
        } catch (error) {
            console.error('SignalR:Settings: Failed to responseCandidateSettings, Error: ', error);
        }
    }
};

export const tryUpdateCandidateSetting = async (deviceType: DeviceType, deviceInfo: string, index: number, userid: string, threadId: string | null): Promise<void> => {
    if (IsInterlocutorMode() || IsProctorMode()) {
        try {
            console.log('SignalR:Settings: updateCandidateSetting');

            let candidate = await connection.invoke("GetUserByUserId", threadId, userid);
            let randonumber = Math.floor(Math.random() * (100000 - 10000)) + 10000;

            if (candidate) {
                let usercomm: string = '';
                let command: string = deviceInfo + "@@@" + index;

                console.log('SignalR:Settings: updateCandidateSetting command: ' + command);
                let checkUserSettings = remoteUserLocalSettingsProps?.find((c) => c.userId === userid);
                if (!checkUserSettings) {
                    requestCandidateSettings(threadId, userid);
                }
                if (deviceType === DeviceType.Camera) {
                    usercomm = '{"ConnectionID":"' + candidate.connectionId + '","UserId":"' + candidate.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.TryUpdateCandidateCamera + ',"Command":"' + command + '"}';
                    if (checkUserSettings) {
                        const camerasettingsIndex = remoteUserLocalSettingsProps.indexOf(checkUserSettings);

                        if (camerasettingsIndex > -1) {
                            remoteUserLocalSettingsProps[camerasettingsIndex].videoIndex = index;
                            remoteUserLocalSettingsProps[camerasettingsIndex].videoDevice = deviceInfo;
                        }
                    }

                }
                else if (deviceType === DeviceType.Microphone) {
                    usercomm = '{"ConnectionID":"' + candidate.connectionId + '","UserId":"' + candidate.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.TryUpdateCandidateMicrophone + ',"Command":"' + command + '"}';

                    if (checkUserSettings) {
                        const microphonesettingsIndex = remoteUserLocalSettingsProps.indexOf(checkUserSettings);

                        if (microphonesettingsIndex > -1) {
                            remoteUserLocalSettingsProps[microphonesettingsIndex].audioIndex = index;
                            remoteUserLocalSettingsProps[microphonesettingsIndex].audioDevice = deviceInfo;
                        }
                    }
                }
                await connection.invoke("SendToUser", usercomm);
            }
        } catch (error) {
            console.error('SignalR:Failed to updateCandidateSetting, Error: ', error);
        }
    }
};

export const readCandidateSettings = (data: string): void => {
    try {
        data = data.toString().replace(/'/g, '"');
        let userSettings = JSON.parse(data);

        let checkUserSettings = remoteUserLocalSettingsProps?.find((c) => c.userId === userSettings.userId);

        if (!checkUserSettings)
            remoteUserLocalSettingsProps.push(userSettings);
        else {
            const settingsIndex = remoteUserLocalSettingsProps.indexOf(checkUserSettings);

            if (settingsIndex > -1) {
                remoteUserLocalSettingsProps.splice(settingsIndex, 1);
            }
            remoteUserLocalSettingsProps.push(userSettings);
        }

        console.log('Settings: remoteUserLocalSettingsProps:' + userSettings?.videoDevice);
    } catch (error) {
        console.error('Settings: Failed to readCandidateSettings, Error: ', error);
    }
};


setInterval(function () {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const threadId = urlParams.get(URLOptionsConstants.THREADID);
    pingRandomSignalRUser(threadId);
}, 180000); //3 minutes

let roundTrip: number[] = [];
export const AddRoundTrip = (pingvalue: number | undefined): void => {
    if (pingvalue !== undefined) {

        roundTrip.push(pingvalue);
    }
};
setInterval(async () => {

    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const threadId = urlParams.get(URLOptionsConstants.THREADID);

    let AddNetDetailsDataOptions = {
        method: 'POST'

    };
    if (threadId !== null) {
        await fetch('/AddTeamsNetDetailsData/' + threadId + '/' + roundTrip.toString(), AddNetDetailsDataOptions).then(
            (response) => {

                if (response.ok) {

                    roundTrip = [];
                    return true;
                } else {
                    return false;
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }

}, 300000); // 5 mins 


export const pingRandomSignalRUser = async (threadId: string | null): Promise<void> => {
    try {
        let isInterlocutor: boolean = false;
        if (IsInterlocutorMode() || IsProctorMode())
            isInterlocutor = true;

        let user = await connection.invoke("GetUserByThreadId", threadId, isInterlocutor);
        let randonumber = Math.floor(Math.random() * (100000 - 10000)) + 10000;

        if (user) {
            let usercomm = '{"ConnectionID":"' + user.connectionId + '","UserId":"' + user.id + '","CommandID":' + randonumber + ',"userCommandType":' + UserCommand.Response + ',"Command":""}';

            await connection.invoke("SendToUser", usercomm);
        }
    } catch (error) {
        console.error('SignalR:Failed to ping Candidate, Error: ', error);
    }
};

export const hasInterlocutorConnected = async (threadId: string): Promise<boolean> => {
    let res: boolean = false;
    try {
        let user = await connection.invoke("GetUserByThreadId", threadId, true);

        if (user) {
            res = true;
        }
        return res;
    } catch (error) {
        return res;
    }
};

const GetBlockedDevices = async (): Promise<string[]> => {
    var list: string[] = [];

    try {
        let options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };

        const res = await fetch('/getdbbanneddevicenames', options);
        const data = await res.json();

        data.forEach((item: any) => {
            if (item) {
                list.push(item.toString());
            }
        });

        return list;
    } catch (error) {
        console.error(error);
        return list;
    }
};

export const setHelpClickedState = (helpClicked: boolean) => {
    return (dispatch: Dispatch, getState: () => State): void =>
    {
        const state = getState();
        state.controls.HelpClicked = helpClicked;
        dispatch(setHelpClicked(helpClicked))
    }
}
/* End SignalR */